import { SET_ASSIGNMENT_RESULTS_TYPE } from './assignment-result-actions';

export const ASSIGNMENT_RESULT_TYPES = {
    HIGHEST: 0,
    TEACHER_ASSIGNED: 1,
    VOLUNTARY: 2
};

const defaultState = ASSIGNMENT_RESULT_TYPES.TEACHER_ASSIGNED;

/**
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type
 * @returns {number} the new state
 */
export default function(state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
        case SET_ASSIGNMENT_RESULTS_TYPE: {
            return action.payload;
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./components/assignment-result/assignment-result-reducer.js